import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';
import { IConfigurationFormatted } from '../../types/project';
import { Configuration } from './components/Configuration';
import * as styles from './Configurations.css';

interface IConfigurationsProps {
  configurations: IConfigurationFormatted[];
}

export const Configurations: React.FC<IConfigurationsProps> = ({ configurations }) => {
  return (
    <div className={styles['container']}>
      <UIHeading1>Комплектация</UIHeading1>
      <div className={styles['list']}>
        {configurations.map((configuration, index) => (
          <Configuration key={index} {...configuration} />
        ))}
      </div>
    </div>
  );
};
